import { Component, Input } from '@angular/core';
import { BaseComponent } from '../../system-common/base/base.component';
import { SettingService } from '../../system-common/services/setting.service';
import { AgentService } from '../services/agent.service';
import { OfflineService } from '../../offline/offline.service';

@Component({
  selector: '',
  template: '',
})
export class AgentPaymentViewHandlerComponent extends BaseComponent<AgentService> {
  public value = 1200;
  constructor(
    agentService: AgentService,
    public settingService: SettingService,
    protected offlineService: OfflineService
  ) {
    super(agentService);
  }
  ngOnInit() {}

  onPaymentClick() {
    if (
      this.settingService.applicationModeView == 'MobileView' &&
      (this.service.responseIO.data.Entity.applicationStatusCd === 'PENDING' ||
        this.service.responseIO.data.Entity.applicationStatusCd === 'PENDINGPAYMENT' ||
        this.service.responseIO.data.Entity.applicationStatusCd === 'REMOTE')
    ) {
      // this.offlineService.onOfflinePayment(this.service);
    } else {
      // this.error(this.settingService.getLabelValue('paymentError'));
      document.forms['paymentGatewayForm'].submit();
    }
  }
}
